import React, { ReactNode, useEffect, useState } from "react";
import Modal from "common/Modal/Modal";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import { OpenConfirmModal } from "@shared/types";
import { LegacyButtonType } from "antd/es/button/button";
import { HookAPI } from "antd/es/modal/useModal";
import { isArray } from "lodash";
import Text from "common/Typography/Text";

interface useConfirmModalProps {
  loading?: boolean;
  title?: string;
  confirmModal?: HookAPI;
  modalWidth?: number;
}

const useConfirmModal = ({
  title,
  loading,
  confirmModal: propsConfirmModal,
  modalWidth,
}: useConfirmModalProps) => {
  const [confirmModalInstance, setConfirmModalInstance] = useState<any>();
  const [confirmModal, confirmModalContextHolder] = Modal.useModal();

  const getModalContent = (confirmStr: ReactNode | string[]) => {
    if (isArray(confirmStr)) {
      return (
        <div style={{ rowGap: 12, display: "grid" }}>
          {confirmStr.map((row) => (
            <Text>{row}</Text>
          ))}
        </div>
      );
    }
    return confirmStr;
  };

  const openConfirmModal: OpenConfirmModal<LegacyButtonType> = (
    confirmStr,
    handleOk,
    okType,
    hideCancel,
    okText,
    cancelText
  ) => {
    setConfirmModalInstance(
      (propsConfirmModal || confirmModal).confirm({
        title: title || "Confirm",
        content: getModalContent(confirmStr),
        icon: <ExclamationCircleOutlined />,
        okText: okText || "Yes",
        okType: okType,
        cancelText: cancelText || "No",
        onOk: handleOk,
        width: modalWidth,
        cancelButtonProps: hideCancel
          ? { style: { display: "none" } }
          : undefined,
      })
    );
  };

  useEffect(() => {
    confirmModalInstance?.update({
      okButtonProps: { loading: loading },
    });
  }, [loading, confirmModalInstance]);

  return { confirmModal, confirmModalContextHolder, openConfirmModal };
};

export default useConfirmModal;
